import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => (
  <article className="privacy-policy">
    <h1>Privacy Policy</h1>
    <p>
      EditImagePro edits your images entirely inside your browser. The image you open is never
      uploaded to us and never leaves your device.
    </p>

    <h2>Information we collect</h2>
    <p>
      We do not collect or store the images you edit. We use Google Analytics to count page views
      and understand which features are used.
    </p>

    <h2>How we use information</h2>
    <p>
      Aggregated, anonymous usage statistics help us decide what to improve. We do not sell or share
      your data.
    </p>

    <h2>Contact</h2>
    <p>
      If you have questions about this policy, please reach out through the project&apos;s
      repository.
    </p>
  </article>
);

export default PrivacyPolicy;
